<div class="mos">
  <div class="mos__head">
    <h2 class="mos__title">Meal Order Summary</h2>
  </div>

  <div class="mos__tabs-wrap">
    <div class="mos__tabs-row">
      <mat-tab-group
        class="mos__tabs mos__tabs--compact"
        [selectedIndex]="selectedTabIndex"
        (selectedIndexChange)="onTabChange($event)"
        animationDuration="200ms">
        <mat-tab label="Today"></mat-tab>
        <mat-tab label="Tomorrow"></mat-tab>
        <mat-tab label="Custom date"></mat-tab>
      </mat-tab-group>

      <div class="mos__tabs-right" *ngIf="selectedTabIndex === 0 || selectedTabIndex === 1">
        <span class="mos__custom-label">Date</span>
        <div class="mos__date-input-wrap mos__date-input-wrap--readonly">
          <input
            type="text"
            class="mos__custom-input mos__custom-input--readonly form-control"
            [value]="activeDateLabel"
            readonly
            tabindex="-1"
            aria-label="Selected date" />
        </div>
      </div>

      <div class="mos__tabs-right" *ngIf="selectedTabIndex === 2">
        <span class="mos__custom-label">Date</span>
        <div class="mos__date-input-wrap">
          <input
            matInput
            [matDatepicker]="summaryPicker"
            [max]="summaryMaxDate"
            [(ngModel)]="customDate"
            (dateChange)="onCustomDateChange()"
            (click)="summaryPicker.open()"
            class="mos__custom-input form-control"
            placeholder="Pick a date" readonly />
          <mat-datepicker-toggle [for]="summaryPicker" class="mos__date-toggle"></mat-datepicker-toggle>
          <mat-datepicker #summaryPicker></mat-datepicker>
        </div>
      </div>
    </div>
  </div>

  <div class="mos__grid-wrap">
    <ag-grid-angular
      class="ag-theme-alpine mos-grid"
      style="width: 100%; height: min(560px, calc(100vh - 260px))"
      [rowData]="rowData"
      [pinnedBottomRowData]="pinnedBottomRowData"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowHeight]="48"
      [overlayLoadingTemplate]="overlayLoadingTemplate"
      [overlayNoRowsTemplate]="overlayNoRowsTemplate"
      [getRowClass]="getRowClass"
      (gridReady)="onGridReady($event)"
      (rowClicked)="onRowClicked($event)">
    </ag-grid-angular>
  </div>
</div>

<ng-container *ngIf="drawerOpen">
  <div
    class="mos__backdrop"
    [class.mos__backdrop--open]="drawerPanelOpen"
    (click)="closeDrawer()"
    aria-hidden="true"></div>
  <aside
    class="mos__sheet"
    [class.mos__sheet--open]="drawerPanelOpen"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="selectedDetail?.campusName ? 'Campus meal details: ' + selectedDetail?.campusName : 'Campus meal details'">
    <app-meal-order-dialog [detail]="selectedDetail" (closed)="closeDrawer()"></app-meal-order-dialog>
  </aside>
</ng-container>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
